import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
@Component({
  standalone: true,
  imports: [IonicModule],
  selector: 'app-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
})
export class WarningModalComponent  implements OnInit {
  @Input() icon!: string;
  @Input() iconColor!: string;
  @Input() title!: string;
  @Input() text!: string;
  
  constructor(private modalCtrl: ModalController) { }
  ngOnInit() {}
  cancel() {
    return this.modalCtrl.dismiss(false, 'cancel');
  }
  confirm() {
    return this.modalCtrl.dismiss(true, 'confirm');
  }
}

